import PageContainer from "../components/layout/PageContainer";
import LoadingSpinner from "../components/common/LoadingSpinner";
import { useApi } from "../hooks/useApi";
import { billingApi } from "../api/billing";
import { formatCurrency } from "../utils/format";

export default function Tariff() {
  const tariff = useApi(() => billingApi.getTariff(), []);

  if (tariff.loading) {
    return <LoadingSpinner message="Loading tariff..." />;
  }

  if (tariff.error) {
    return (
      <PageContainer title="Tariff" description="Current rates and pricing">
        <div className="rounded-lg border border-amber-200 bg-amber-50 p-4">
          <p className="text-sm text-amber-700">
            Unable to load tariff: {tariff.error}
          </p>
        </div>
      </PageContainer>
    );
  }

  const tariffData = tariff.data?.data;

  return (
    <PageContainer
      title="Tariff"
      description={tariffData ? `${tariffData.name}` : "Current rates and pricing"}
    >
      <div className="space-y-6">
        {tariffData?.rates && tariffData.rates.length > 0 ? (
          <div className="overflow-hidden rounded-lg border border-gray-200 bg-white">
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
                      Network / Country
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
                      Data Rate (per MB)
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500">
                      SMS Rate
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {tariffData.rates.map((rate, idx) => (
                    <tr key={idx} className={idx % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                      <td className="whitespace-nowrap px-4 py-3 text-sm text-gray-900">
                        {rate.network || rate.country || "Default"}
                      </td>
                      <td className="whitespace-nowrap px-4 py-3 text-sm text-gray-900">
                        {rate.dataRatePerMb != null
                          ? formatCurrency(rate.dataRatePerMb)
                          : "—"}
                      </td>
                      <td className="whitespace-nowrap px-4 py-3 text-sm text-gray-900">
                        {rate.smsRate != null
                          ? formatCurrency(rate.smsRate)
                          : "—"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <div className="rounded-lg border border-gray-200 bg-white p-8 text-center">
            <p className="text-sm text-gray-500">
              {tariffData
                ? "No rate details available for your current tariff"
                : "No tariff information available"}
            </p>
          </div>
        )}

        <div className="rounded-lg border border-blue-200 bg-blue-50 p-4">
          <p className="text-sm text-blue-700">
            Rates are charged automatically from your account balance. All
            amounts shown include VAT where applicable.
          </p>
        </div>
      </div>
    </PageContainer>
  );
}
